// extracted by mini-css-extract-plugin
export default {"header":"header_header__JPpAt","link":"header_link__XHsZy","subLink":"header_subLink__rDylA","dropdownFooter":"header_dropdownFooter__Hd9YD"};